import {
  TApiTaskEntity,
  TaskPriorityType,
  TaskStatusType,
} from "../types/Tasks";

export const filterTasks = (
  tasks: TApiTaskEntity[],
  search: string,
  statuses: TaskStatusType[],
  priorities: TaskPriorityType[]
): TApiTaskEntity[] => {
  const phrase = search.toLowerCase();

  return tasks.filter((task) => {
    const statusMatch =
      statuses.length === 0 ||
      (task.statusType !== null && statuses.includes(task.statusType));

    const priorityMatch =
      priorities.length === 0 ||
      (task.priorityType !== null && priorities.includes(task.priorityType));

    const searchMatch = !phrase || task.title.toLowerCase().includes(phrase);

    return statusMatch && priorityMatch && searchMatch;
  });
};
